import React from "react";
import DataGrid, {
  Column,
  Export,
  Scrolling,
  Grouping,
} from "devextreme-react/data-grid";
import ExcelJS from "exceljs";
import saveAs from "file-saver";
import Paper from "@material-ui/core/Paper";
import "../../styles/css/ReservationTable.css";
/*
  // Use this import for codeSandBox
  import FileSaver from 'file-saver';
*/
import { exportDataGrid } from "devextreme/excel_exporter";

class ReservationTable extends React.Component {
  constructor(props) {
    super(props);
    this.attendees = props.attendees;
    this.onExporting = this.onExporting.bind(this);
  }

  render() {
    return (
      <Paper
        style={{
          height: "100%",
          width: "58%",
          overflow: "hidden",
        }}
      >
        <DataGrid
          id="gridContainer"
          dataSource={this.props.attendees}
          onExporting={this.onExporting}
        >
          <Grouping autoExpandAll={true} />

          <Column caption="Apellido" dataField="lastName" sortOrder="asc" />
          <Column caption="Nombre" dataField="name" />
          <Column caption="DNI" dataField="dni" />

          <Scrolling mode="infinite" />

          <Export enabled={true} />
        </DataGrid>
      </Paper>
    );
  }

  onExporting(e) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");

    exportDataGrid({
      component: e.component,
      worksheet: worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "Asistentes.xlsx"
        );
      });
    });
    e.cancel = true;
  }
}

export default ReservationTable;
